
export const BulkUploadReducer = (state, action) => {
  switch (action.type) {
    case 'uploading':     
    return { ...state, uploadingUsers: true };
    case 'loaded':     
    return { ...state, uploadingUsers: false , messageBulkshow: false}; 
    case 'MessageBulk':     
    return { ...state,  uploadingUsers: false, messageBulkshow: true, messageBulk:{success:action.payload.success,message:action.payload.message}  }; 
    default: throw new Error('Unexpected action');
  }
};

